import moment from 'moment';

const FORMATOS = ['YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY', 'DD/MM/YYYY HH:mm', moment.ISO_8601];

/** Converte a data de follow-up vinda da API (ISO ou dd/mm/aaaa). Retorna null se inválida. */
export const lerData = (valor) => {
    if (!valor) return null;
    const d = moment(valor, FORMATOS, true);
    return d.isValid() ? d.startOf('day') : null;
};

/**
 * Situação do follow-up para exibir no card do board (Gestão do Assessor):
 *  - atrasado     → "Atrasado 3 dias"                              (vermelho)
 *  - hoje até 7d  → "Vence hoje", "Vence amanhã", "Vence em 4 dias" (amarelo)
 *  - depois de 7d → "15/01"                                         (verde)
 */
export const situacaoFollowUp = (valor, hoje = moment().startOf('day')) => {
    const d = lerData(valor);
    if (!d) return null;
    const dias = d.diff(hoje, 'days');
    if (dias < 0) {
        const n = Math.abs(dias);
        return { tom: 'erro', texto: `Atrasado ${n} ${n === 1 ? 'dia' : 'dias'}`, data: d };
    }
    if (dias === 0) return { tom: 'alerta', texto: 'Vence hoje', data: d };
    if (dias === 1) return { tom: 'alerta', texto: 'Vence amanhã', data: d };
    if (dias <= 7) return { tom: 'alerta', texto: `Vence em ${dias} dias`, data: d };
    return { tom: 'ok', texto: d.format('DD/MM'), data: d };
};

/** Iniciais para o avatar do assessor ("Ana Paula Souza" → "AP"). */
export const iniciais = (nome) => {
    const partes = String(nome || '').trim().split(/\s+/).filter(Boolean);
    if (partes.length === 0) return '—';
    if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
    return (partes[0][0] + partes[1][0]).toUpperCase();
};
